import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { HeaderKey } from "@shared/clickar-constants";
import { Observable } from "rxjs";

@Injectable()
export class WcmService {
	headers;

	// IMG
	logoUrl = "assets/img/logo.svg"; // environment.baseWcmImageUrl+'/294d3877-183d-458f-ab3a-f650b66c13ee/logo.png?MOD=AJPERES&CVID=mcnUzLi&CACHE=NONE';
	logoSpainUrl = "assets/img/Logo-Leasys-Automarket.png"; // environment.baseWcmImageUrl+'/294d3877-183d-458f-ab3a-f650b66c13ee/logo.png?MOD=AJPERES&CVID=mcnUzLi&CACHE=NONE';
	topBannerUrl = "assets/img/top-banner.jpg";
	scrollDownUrl = "assets/img/scroll-down.png";
	sellUrl = "assets/img/sell.png";
	myClickarUrl = "assets/img/my-clickar.png";
	loginIconUrl = "assets/img/login-icon.png";
	scadenzaBolloUrl = "assets/img/scadenza-bollo.png";
	praticheAutoUrl = "assets/img/pratiche-auto.png";
	astaIcon = "assets/img/asta.png";
	registratiIconUrl = "assets/img/register-icon.png";
	maintenanceUrl = "assets/img/crash.png";
	clickarIconUrl = "assets/img/clickar-icon.png";
	googleStoreUrl = "assets/img/google-play.png";
	appleStoreUrl = "assets/img/apple-store.png";
	aziendaIconUrl = "assets/img/azienda.png";
	partnerIconUrl = "assets/img/02_leasys_clickar_comefunziona_07_30_01.png"; // environment.baseWcmImageUrl+'/4bed8fa6-d2bb-4a69-b945-e40d076c4141/partner.png?MOD=AJPERES&CVID=mcnUzLi'
	costoIconUrl = "assets/img/03_leasys_clickar_achicirivolgiamo_07_30_01.png";
	deIcon1 = "assets/img/Picture1.png";
	deIcon2 = "assets/img/Picture2.png";
	deIcon3 = "assets/img/Picture3.png";
	deIcon4 = "assets/img/Picture4.png";
	deIcon5 = "assets/img/Picture5.png";
	registrarsi1Url = "assets/img/01.png";
	registrarsi2Url = "assets/img/02.png";
	registrarsi3Url = "assets/img/leasys_clickar_icona_step3_07_30_03.png"; // environment.baseWcmImageUrl+'/4b77da0c-6d3e-48f7-99f7-8a308f9b315e/03.png?MOD=AJPERES&CVID=mcnUzLi&CACHE=NONE';
	customerCenMailUrl = "assets/img/mail.png";
	customerCenCelUrl = "assets/img/tel.png";
	avvisoUrl = "assets/img/avviso.png";
	offerteUrl = "assets/img/offerte.png";
	riservaUrl = "assets/img/prezzo.png";
	inizioAstaUrl = "assets/img/calendario.png";
	chiusuraUrl = "assets/img/chiusura.png";
	assistenzaUrl = "assets/img/phone.png";
	statoUrl = "assets/img/progress.png";
	volanteUrl = "assets/img/car.png";
	carsUrl = "assets/img/cars.png";
	numAsteUrl = "assets/img/num-aste.png";
	noPhotoUrl = "/assets/img/no-photo.svg";
	trashCircleUrl = "assets/icons/bin.svg";
	iconYellowUrl = "assets/img/iconGiallo.png";
	iconGreenUrl = "assets/img/iconVerde.png";
	iconRedUrl = "assets/img/redicon.png";
	uploadIconUrl = "assets/img/plus-circle-solid.svg";
	submitUrl = "assets/img/submit.png";
	infoUrl = "assets/img/info.png";
	showcaseFRUrl = "assets/img/01_FZ939LW.JPG";

	// PDF
	presentazClickarITUrl = "assets/docs/Presentazione_Clickar_IT.pdf";
	presentazClickarBEUrl = "assets/docs/Presentazione_Clickar_BE.pdf";
	presentazClickarDEUrl = "assets/docs/Clickar_Leitfaden_Gebrauchtwagenbörse.pdf";
	presentazClickarNLUrl = "assets/docs/Presentazione_Clickar_NL.pdf";
	presentazClickarFRUrl = "assets/docs/Guide_Clickar.pdf";
	presentazClickarENUrl = "assets/docs/Presentazione_Clickar_EN.pdf";
	presentazClickarESUrl = "assets/docs/Presentazione_Clickar_ES.pdf";

	constructor(
		protected http: HttpClient
	) {
		const _header = {};
		_header[HeaderKey.NO_POPUP] = "true";
		this.headers = _header;
	}

	getWcmPrivacy = (country: string = "it"): Observable<string> =>
		this.http.get(`assets/privacy/privacy-page-${country}.html`, {
			responseType: "text"
		});
}